"use client"

import React from 'react';
import PropTypes from 'prop-types';
import CounterArrows from "../../assets/counter-arrows.svg";
import { motion, useInView } from "framer-motion";

const SecurityBubble = ({ blok }) => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <div ref={ref} className="relative py-12 px-4 lg:px-6 overflow-hidden min-h-[1150px] lg:min-h-[850px] w-full z-0 md:bg-inherit bg-gradient-to-b from-white/0 via-white/80 to-white 2xl:bg-none"
    >
      {/* Section Title */}
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8 }}
        className='flex flex-col items-center'
      >
        <h2 className="text-[24px] lg:text-[48px] bg-custom-radial bg-clip-text text-transparent text-center font-bold">
          {blok.securityBubbleHeader}
        </h2>
        <p className="text-[16px] lg:text-[18px] text-center mt-4 font-normal mb-20 max-w-4xl">
          {blok.securityBubbleDescription}
        </p>
      </motion.div>

      {/**Circles */}
      <div className="flex flex-wrap justify-center mt-[-100px] lg:mt-0">
        <motion.div className="flex gap-2 justify-center lg:justify-start flex-col items-center w-[100%] md:w-[80%] relative aspect-square lg:w-[320px] lg:h-[320px] xl:w-[420px] xl:h-[420px] md:!translate-y-[20%] lg:!translate-x-[10%] !translate-y-[12%] lg:!translate-y-0"
          initial={{ translateX: -100 }}
          animate={isInView ? { translateX: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div
            className="absolute z-0 flex  h-full w-full bg-gradient-to-b from-[#D259A6]/10 to-[#5A27E7]/10
 rounded-full"
            // style={{
            //   opacity: 0.2,
            //   background: "linear-gradient(164.04deg, #5A27E7 7.94%, #D259A6 56.14%, #FDDAF0 81.04%, #FFFFFF 91.72%, #FFFFFF 92.06%)"

            // }}
          />
          <motion.img
            src={"/images/counter-arrows.svg"}
            alt="Counter Arrows"
            className="hidden lg:block w-6 h-6 lg:w-10 lg:h-20 filter grayscale invert !opacity-30 absolute self-center top-[50%] translate-y-[-50%] right-[-0px]"
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : {}}
            transition={{ duration: 0.8, delay: 1.6 }}
          />
          <div className="hidden lg:block  absolute  bottom-0 top-[84%] md:top-[90%] xl:top-[84%]  left-14 h-[200px] w-[80%]" 
          style={{borderLeft:"solid 1px #B0ABF9"}}>
            <motion.div
              initial={{ opacity: 0, x: -100 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.4 }}
              style={{borderRight:"solid 1px #B0ABF9"}}
            >
            </motion.div>

            <div className="lg:block absolute left-10 bottom-0 w-[100%] text-[18px] xl:text-[24px]">
              {blok.securityCircleText1} <br /> {blok.securityBubbleSubText1}
            </div>
          </div>
          <div className="hidden text-black lg:hidden">Your Know & Unknown Assets</div>
          <div className="flex flex-wrap md:mt-8 xl:mt-14 z-10">
            {/** Two row format */}
            {blok?.securityCircleIconsAndText?.reduce((acc, item, index, array) => {
              if (index % 2 === 0) {
                acc.push(array.slice(index, index + 2));
              }
              return acc;
            }, []).map((pair, pairIndex) => (
              <div key={pairIndex} className="flex w-full justify-center gap-4 lg:gap-2">
                {pair.map((item, index) => (
                  <div key={index} className="w-14 sm:w-16 md:w-20 lg:w-14 xl:w-20  flex flex-col items-center justify-start">
                    <div
                      className="flex items-center justify-center rounded-full w-10  h-10 sm:w-16 sm:h-16 
                      xl:w-16 xl:h-16 lg:w-12 lg:h-12 shadow-lg"
                      style={{
                        background:
                          "linear-gradient(209.64deg, #D259A6 13.62%, #48398C 86.47%)",
                      }}
                    >
                      <img
                        src={item.filename}
                        alt={item.alt}
                        className="w-4 h-4 xl:w-8 xl:h-8"
                      />
                    </div>
                    <span className=" lg:w-20  h-max text-[12px] xl:text-[14px] mt-1 font-aileron lg:h-6 text-center">
                      {item.alt}
                    </span>
                  </div>
                ))}
              </div>
            ))}
          </div>


        </motion.div>
        <motion.div className="flex gap-2 justify-center lg:justify-start flex-col items-center w-[100%] md:w-[80%] relative aspect-square lg:w-[320px] lg:h-[400px] xl:w-[420px] xl:h-[500px]"
          initial={{ x: -100 }}
          animate={isInView ? { x: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="absolute flex aspect-square bg-gradient-to-b from-[#5A27E7]/10 to-[#D259A6]/10  w-full rounded-full"
            // style={{
            //   opacity: 0.3,
            //   background: "linear-gradient(164.04deg, #5A27E7 7.94%, #D259A6 56.14%, #FDDAF0 81.04%, #FFFFFF 91.72%, #FFFFFF 92.06%)"

            // }} 
            />
          <motion.img
            src={"/images/counter-arrows.svg"}
            alt="Counter Arrows"
            className="hidden lg:block w-6 h-6 lg:w-10 lg:h-20 filter grayscale invert !opacity-30 absolute self-center top-[41%] translate-y-[-50%] right-[-0px]"
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : {}}
            transition={{ duration: 0.8, delay: 1.6 }}
          />
          <div className="hidden lg:block absolute  bottom-0 top-[50%] md:top-[48%] xl:top-[50%] left-0 h-[300px] w-[80%]" style={{borderLeft:"solid 1px #B0ABF9"}}>
            <motion.div
              initial={{ opacity: 0, x: -100 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.4 }}
              // style={{borderRight:"solid 1px #B0ABF9"}}

            >
            </motion.div>

            <div className="lg:block absolute left-10 bottom-0 w-[100%]  text-[18px] xl:text-[24px]">
            {blok.securityCircleText2} <br /> {blok.securityBubbleSubText2}
            </div>
          </div>
          <div className="hidden text-black lg:hidden w-[70%] text-center">Early Warning Security Intelligence</div>
          <div className="flex flex-wrap md:mt-16  xl:mt-24  z-10">
            {/** Two row format */}
            {blok?.securityCircleIconsAndText2?.reduce((acc, item, index, array) => {
              if (index % 2 === 0) {
                acc.push(array.slice(index, index + 2));
              }
              return acc;
            }, []).map((pair, pairIndex) => (
              <div key={pairIndex} className="flex w-full justify-center  gap-4 lg:gap-2">
                {pair.map((item, index) => (
                  <div key={index} className="w-14 md:w-20  sm:w-16 lg:w-14 xl:w-20 flex flex-col items-center h-max justify-start">
                    <div
                      className="flex items-center justify-center rounded-full w-10 h-10  sm:w-16 sm:h-16 xl:w-16 xl:h-16 lg:w-12 lg:h-12  shadow-lg"
                      style={{
                        background:
                          "linear-gradient(209.64deg, #D259A6 13.62%, #48398C 86.47%)",
                      }}
                    >
                      <img
                        src={item.filename}
                        alt={item.alt}
                        className="w-4 h-4 xl:w-8 xl:h-8"
                      />
                    </div>
                    <span className="lg:w-20  !h-max text-[12px] xl:text-[14px] mt-1 font-aileron lg:h-6 text-center">
                      {item.alt}
                    </span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </motion.div>
        {/**3rd circle desktop */}
        <motion.div className="hidden lg:flex gap-2 justify-center lg:justify-start relative flex-col items-center  w-[100%] aspect-square lg:w-[320px] lg:h-[400px] xl:w-[420px] xl:h-[500px] rounded-full lg:!translate-x-[-10%] translate-y-[1%] md:!translate-y-[-15%] lg:!translate-y-0"
          initial={{ x: -100 }}
          animate={isInView ? { x: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div
            className="absolute flex aspect-square w-full bg-gradient-to-b from-[#D259A6]/10 to-[#5A27E7]/10 rounded-full"
            // style={{
            //   opacity: 0.2,
            //   background: "linear-gradient(164.04deg, #D259A6 7.94%, #48398C 92.06%)"
            // }} 
            />
          <div className="text-black lg:hidden">Securin Capabilities</div>
          <div className="hidden lg:block absolute  bottom-0 top-[50%] md:top-[48%] xl:top-[50%]  left-0 h-[300px] w-[80%]" style={{borderLeft:"solid 1px #B0ABF9"}}>
            <motion.div
              initial={{ opacity: 0, x: -100 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.4 }}
              // style={{borderRight:"solid 1px #B0ABF9"}}

            >
              {/* <img
                src={Line}
                alt="Counter Arrows"
                className="h-[300px]"
              /> */}
            </motion.div>

            <div className="lg:block absolute left-10 bottom-0 w-[100%] text-[18px] xl:text-[24px]">
            {blok.securityCircleText3} <br /> {blok.securityBubbleSubText3}
            </div>
          </div>
          <div className="flex flex-col flex-wrap lg:mt-5 xl:mt-10  z-10">
            {blok?.securityCircleIconsAndText3?.slice(0, 2).reduce((acc, item, index, array) => {
              if (index % 2 === 0) {
                acc.push(array.slice(index, index + 2));
              }
              return acc;
            }, []).map((pair, pairIndex) => (
              <div key={pairIndex} className="flex w-full justify-center lg:gap-2">
                {pair.map((item, index) => (
                  <div key={index} className="w-14 xl:w-20 h-max lg:w-14 flex  sm:w-16 flex-col items-center justify-start">
                    <div
                      className="flex items-center justify-center rounded-full w-10 h-10 lg:w-12 lg:h-12  sm:w-16 sm:h-16  xl:w-16 xl:h-16 md:w-12 md:h-12 shadow-lg"
                      style={{
                        background:
                          "linear-gradient(209.64deg, #D259A6 13.62%, #48398C 86.47%)",
                      }}
                    >
                      <img
                        src={item.filename}
                        alt={item.alt}
                        className="w-4 h-4 xl:w-8 xl:h-8"
                      />
                    </div>
                    <span className="lg:w-20 !h-max text-[12px] xl:text-[14px] mt-1 font-aileron lg:h-6 text-center">
                      {item.alt}
                    </span>
                  </div>
                ))}
              </div>
            ))}
            {/** Two row format */}
            {blok?.securityCircleIconsAndText3?.slice(2).reduce((acc, item, index, array) => {
              if (index % 4 === 0) {
                acc.push(array.slice(index, index + 4));
              }
              return acc;
            }, []).map((pair, pairIndex) => (
              <div key={pairIndex} className="flex w-full justify-center lg:gap-2">
                {pair.map((item, index) => (
                  <div key={index} className="w-14 sm:w-16 xl:w-20 lg:w-14   h-max flex flex-col items-center justify-start">
                    <div
                      className="flex items-center justify-center rounded-full w-10 h-10 lg:w-12 lg:h-12  sm:w-16 sm:h-16 xl:w-16 xl:h-16  shadow-lg"
                      style={{
                        background:
                          "linear-gradient(209.64deg, #D259A6 13.62%, #48398C 86.47%)",
                      }}
                    >
                      <img
                        src={item.filename}
                        alt={item.alt}
                        className="w-4 h-4 xl:w-8 xl:h-8"
                      />
                    </div>
                    <span className="lg:w-20 !h-max text-[12px] lg:text-[14px] mt-1 font-aileron lg:h-6 text-center">
                      {item.alt}
                    </span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </motion.div>
        {/**3rd circle mobile */}
        <motion.div
          className="lg:hidden flex gap-2 justify-center lg:justify-start relative flex-col items-center  w-[100%] md:w-[80%] aspect-square lg:w-[420px] lg:h-[420px] rounded-full lg:!translate-x-[-10%] md:!translate-y-[-20%] !translate-y-[-12%] lg:!translate-y-0"
          initial={{ x: -100 }}
          animate={isInView ? { x: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div
            className="absolute flex h-full w-full rounded-full"
            style={{
              opacity: 0.2,
              background: "linear-gradient(164.04deg, #D259A6 7.94%, #48398C 92.06%)"
            }} />
          <div className="hidden text-black lg:hidden">Securin Capabilities</div>
          <div className="flex flex-col flex-wrap mt-4 lg:mt-14 z-10">
            {/** Two row format */}
            {blok?.securityCircleIconsAndText3?.reduce((acc, item, index, array) => {
              if (index % 3 === 0) {
                acc.push(array.slice(index, index + 3));
              }
              return acc;
            }, []).map((pair, pairIndex) => (
              <div key={pairIndex} className="flex w-full justify-center gap-0 sm:gap-2 md:gap-0">
                {pair.map((item, index) => (
                  <div key={index} className="w-14 md:w-20   sm:w-16 lg:w-14 xl:w-20 flex  h-max flex-col items-center justify-start">
                    <div
                      className="flex items-center justify-center rounded-full w-10 h-10  sm:w-16 sm:h-16 xl:w-16 xl:h-16 shadow-lg"
                      style={{
                        background:
                          "linear-gradient(209.64deg, #D259A6 13.62%, #48398C 86.47%)",
                      }}
                    >
                      <img
                        src={item.filename}
                        alt={item.alt}
                        className="w-4 h-4 lg:w-8 lg:h-8"
                      />
                    </div>
                    <span className="lg:w-20 h-auto text-[10px] lg:text-[14px] mt-1 font-aileron lg:h-6 text-center">
                      {item.alt}
                    </span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
};
SecurityBubble.propTypes = {
  blok: PropTypes.shape({
    securityBubbleHeader: PropTypes.string.isRequired,
    securityBubbleDescription: PropTypes.string.isRequired,
    securityCircleText1: PropTypes.string.isRequired,
    securityBubbleSubText1: PropTypes.string.isRequired,
    securityCircleText2: PropTypes.string.isRequired,
    securityBubbleSubText2: PropTypes.string.isRequired,
    securityCircleText3: PropTypes.string.isRequired,
    securityBubbleSubText3: PropTypes.string.isRequired,
    securityCircleIconsAndText: PropTypes.arrayOf(PropTypes.shape({
      filename: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired
    })),
    securityCircleIconsAndText2: PropTypes.arrayOf(PropTypes.shape({
      filename: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired
    })),
    securityCircleIconsAndText3: PropTypes.arrayOf(PropTypes.shape({
      filename: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired
    }))
  })
};

export default SecurityBubble;